@let hasVoted = voted();

<app-form-wrapper [title]="(hasVoted ? 'voting.form_bg_voted' : 'voting.form_bg_vote') | translate">
  @if (isDeadlinePassed()) {
    <div class="title-xl">{{ 'voting.form_header' | translate }}</div>
    <div class="mt-xl deadline-notification">
      <i class="icon icon--status-warning icon--color--warning icon--size--20"></i>
      <div class="body-md">{{ 'voting.voting_ended' | translate:({voteDeadline: voteDeadlineStr()}) }}</div>
    </div>
    <app-timezone />
  } @else {
    @if (hasVoted) {
      <div class="body-lg voted-notification">{{ 'voting.voted_date' | translate:({votedDate: votedDateStr()}) }}</div>
    }
    @if (!hasVoted) {
      <div class="title-xl">{{ 'voting.form_header' | translate }}</div>
      <mat-radio-group class="radio-group mt-xl"
                       color="primary"
                       [ngModel]="votingDecision()"
                       (ngModelChange)="updateVotingDecision($event)">
        <mat-radio-button [value]="VoteValue.ACCEPT">{{ 'voting.accept' | translate }}</mat-radio-button>
        <mat-radio-button [value]="VoteValue.DECLINE">{{ 'voting.decline' | translate }}</mat-radio-button>
        <mat-radio-button [value]="VoteValue.ABSTAIN">{{ 'voting.abstain' | translate }}</mat-radio-button>
      </mat-radio-group>
      <button mat-raised-button
              class="mt-xl"
              color="primary"
              [disabled]="previewMode()"
              (click)="onDecisionDone()"> {{ 'voting.submit_vote' | translate }}
      </button>
      @if (voteDeadline()) {
        <div class="mt-xl deadline-notification">
          <i class="icon icon--status-alert-info icon--size--20 bg-primary"></i>
          <div class="body-md">{{ 'voting.vote_till_deadline' | translate:({voteDeadline: voteDeadlineStr()}) }}</div>
        </div>
        <app-timezone />
      }
    }
  }
</app-form-wrapper>
